<template>
  <div
    :id="id"
    class="modal-wrapper"
    :class="{ opened: opened }"
    :data-size="size"
  >
    <div class="modal-mask"></div>
    <div
      class="modal-container"
      :style="'margin-top: -' + negativeMargin + 'px'"
    >
      <div class="modal">
        <div class="modal--header">
          <h1>{{ title }}</h1>

          <span class="modal--close-icon" @click="closeModal"
            ><div class="icon icon-close icon--s"></div
          ></span>
        </div>
        <div class="modal--body">
          <slot name="content"></slot>
        </div>
        <div class="modal--footer">
          <slot name="buttons"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    id: String,
    title: String,
    size: String
  },
  data() {
    return {
      opened: false,
      negativeMargin: window.innerWidth > 768 ? 200 : 0
    };
  },
  created() {
    this.$root.$on(`openModal@${this.id}`, this.openModal);
    this.$root.$on(`closeModal@${this.id}`, this.closeModal);
  },
  destroyed() {
    this.$root.$off(`openModal@${this.id}`, this.openModal);
    this.$root.$off(`closeModal@${this.id}`, this.closeModal);
  },
  methods: {
    openModal() {
      console.log("opening modal", this.id);
      this.opened = true;

      //center to the page
      const isDesktop = window.innerWidth > 768;
      if (isDesktop) {
        setTimeout(() => {
          var x = document
            .getElementById(this.id)
            .querySelector(".modal-container");
          this.negativeMargin = parseInt(x.offsetHeight / 2);
        }, 10);
      }
    },
    closeModal() {
      this.opened = false;
      //this.$root.$emit(`closedModal`);
    }
  }
};
</script>
